import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import queryString from "query-string";
import App from "./components/App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

const qrMode = queryString.parse(location.search).appMode === "qr";

root.render(
	<StrictMode>
		<App qrMode={qrMode}/>
	</StrictMode>
);
